// src/Step3FitnessGoal.jsx
import React from 'react';

const GOAL_OPTIONS = [
  { value: '0', label: 'کاهش وزن', icon: '🔥' },
  { value: '1', label: 'عضله‌سازی', icon: '💪' },
  { value: '2', label: 'تناسب اندام عمومی', icon: '⚖️' },
  { value: '3', label: 'افزایش قدرت', icon: '🏋️' },
  { value: '4', label: 'افزایش استقامت', icon: '🏃' },
  { value: '5', label: 'بازتوانی', icon: '🧘' },
];

const EXPERIENCE_OPTIONS = [
  { value: '0', label: 'بدون سابقه' },
  { value: '1', label: 'مبتدی' },
  { value: '2', label: 'متوسط' },
  { value: '3', label: 'پیشرفته' },
];

const BODY_FOCUS_OPTIONS = [
  { value: '0', label: 'کل بدن', icon: '🧍' },
  { value: '1', label: 'شکم و میان‌تنه', icon: '🎯' },
  { value: '2', label: 'بالاتنه', icon: '💪' },
  { value: '3', label: 'پایین‌تنه', icon: '🦵' },
  { value: '4', label: 'پا و باسن', icon: '🍑' },
];

export default function Step3FitnessGoal({ form, setF, colors }) {
  const isDietOnly = Number(form.requestedPlan) === 2;

  return (
    <div>
      <SectionIntro
        colors={colors}
        title="هدفت از برنامه چیه؟"
        subtitle="هدف و سابقه تمرینی مشخص می‌کند برنامه با چه شدت، حجم و ساختاری طراحی شود."
      />

      <FieldTitle colors={colors}>هدف اصلی</FieldTitle>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3 mb-6">
        {GOAL_OPTIONS.map((item) => (
          <OptionCard
            key={item.value}
            active={String(form.goal) === String(item.value)}
            title={item.label}
            icon={item.icon}
            onClick={() => setF('goal', item.value)}
            colors={colors}
          />
        ))}
      </div>

      <FieldTitle colors={colors}>سابقه تمرینی</FieldTitle>

      <div className="grid sm:grid-cols-4 gap-3 mb-6">
        {EXPERIENCE_OPTIONS.map((item) => (
          <CompactChoice
            key={item.value}
            active={String(form.fitnessExperience) === String(item.value)}
            title={item.label}
            onClick={() => setF('fitnessExperience', item.value)}
            colors={colors}
          />
        ))}
      </div>

      {!isDietOnly && (
        <>
          <FieldTitle colors={colors}>تمرکز اصلی برنامه</FieldTitle>

          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3">
            {BODY_FOCUS_OPTIONS.map((item) => (
              <OptionCard
                key={item.value}
                active={String(form.bodyFocus) === String(item.value)}
                title={item.label}
                icon={item.icon}
                onClick={() => setF('bodyFocus', item.value)}
                colors={colors}
              />
            ))}
          </div>

          <div
            className="mt-5 rounded-2xl border px-4 py-3 text-sm leading-7"
            style={{
              borderColor: colors.border,
              backgroundColor: 'rgba(37,99,235,0.08)',
              color: colors.sub,
            }}
          >
            اگر مطمئن نیستی، گزینه «کل بدن» بهترین انتخاب پیش‌فرضه.
          </div>
        </>
      )}

      {isDietOnly && (
        <div
          className="mt-5 rounded-2xl border px-4 py-3 text-sm leading-7"
          style={{
            borderColor: colors.border,
            backgroundColor: 'rgba(124,58,237,0.08)',
            color: colors.sub,
          }}
        >
          چون برنامه انتخابی فقط رژیم و تغذیه است، تمرکز ناحیه تمرینی در این مرحله نیاز نیست.
        </div>
      )}
    </div>
  );
}

function SectionIntro({ title, subtitle, colors }) {
  return (
    <div
      className="mb-5 rounded-2xl border p-4"
      style={{
        borderColor: colors.border,
        backgroundColor: 'rgba(255,255,255,0.03)',
      }}
    >
      <h3 className="text-lg md:text-xl font-black mb-2">{title}</h3>
      <p className="text-sm leading-7" style={{ color: colors.sub }}>
        {subtitle}
      </p>
    </div>
  );
}

function FieldTitle({ children, colors }) {
  return (
    <h4 className="text-sm font-black mb-3" style={{ color: colors.text }}>
      {children}
    </h4>
  );
}

function OptionCard({ active, title, icon, onClick, colors }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="rounded-[22px] border p-4 text-right transition hover:scale-[1.01]"
      style={{
        borderColor: active ? '#3b82f6' : colors.border,
        backgroundColor: active ? 'rgba(37,99,235,0.16)' : colors.inputBg,
        boxShadow: active ? '0 16px 35px rgba(37,99,235,0.16)' : 'none',
      }}
    >
      <div className="flex items-center justify-between gap-3">
        <div className="flex items-center gap-3">
          <span className="text-2xl">{icon}</span>
          <span className="font-black text-sm md:text-base">{title}</span>
        </div>

        <span
          className="w-6 h-6 rounded-full border flex items-center justify-center text-xs shrink-0"
          style={{
            borderColor: active ? '#60a5fa' : colors.border,
            backgroundColor: active ? '#2563eb' : 'transparent',
            color: '#fff',
          }}
        >
          {active ? '✓' : ''}
        </span>
      </div>
    </button>
  );
}

function CompactChoice({ active, title, onClick, colors }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="rounded-2xl border px-4 py-3 text-center font-bold transition hover:scale-[1.01]"
      style={{
        borderColor: active ? '#3b82f6' : colors.border,
        backgroundColor: active ? 'rgba(37,99,235,0.16)' : colors.inputBg,
        color: active ? '#bfdbfe' : colors.text,
      }}
    >
      {title}
    </button>
  );
}